import Parse from "parse";
import { markSessionInvalid, purgeSession } from "../../utils/sessionGuard";

export default {
  namespaced: true,
  state: () => ({
    user: null,
    tutorialComplete: false,
  }),
  getters: {
    currentUser: (state) => state.user,
    isAuthenticated: (state) => !!state.user,
    username: (state) => state.user?.get("username") ?? null,
    tutorialComplete: (state) => state.tutorialComplete,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      state.tutorialComplete = user?.get("tutorialComplete") === true;
    },
    SET_TUTORIAL_COMPLETE(state) {
      state.tutorialComplete = true;
    },
  },
  actions: {
    async login({ commit }, { username, password }) {
      const user = await Parse.User.logIn(username, password);
      commit("SET_USER", user);
      return user;
    },
    async signup({ commit }, { username, password }) {
      const user = new Parse.User();
      user.set("username", username);
      user.set("password", password);
      user.set("postCount", 0);
      const newUser = await user.signUp();
      commit("SET_USER", newUser);
      return newUser;
    },
    async logout({ commit }) {
      await purgeSession();
      commit("SET_USER", null);
    },
    async sessionExpired({ commit }) {
      markSessionInvalid();
      await purgeSession();
      commit("SET_USER", null);
    },
    async markTutorialComplete({ commit, state }) {
      if (state.tutorialComplete) return;
      if (typeof window !== "undefined") {
        window.localStorage.setItem("scrawl_tutorial_complete", "true");
      }
      // Commit optimistically so hasActiveTutorial reacts immediately.
      commit("SET_TUTORIAL_COMPLETE");
      const user = state.user;
      if (!user) return;
      try {
        await Parse.Cloud.run("markTutorialComplete");
        user.set("tutorialComplete", true);
      } catch (e) {
        // Network / auth blip. The localStorage cache and the committed store
        // state suppress the tutorial this session; next login re-checks the
        // server flag.
      }
    },
  },
};
